<!-- 病例搜索 -->
<template>
	<div>
		<search :keyWords="searchKeyWord" @goSearch="getSearchList"></search>
	</div>
</template>
<script>
	import Search from '../../components/Search';
	import RowItemList from "../../components/RowItemList"; 
	import {CaseSearch} from "../../config/interface.js"
	export default{
		components:{
			Search,
			RowItemList
		},
		data(){
			return{
				searchKeyWord:'',      //关键词   
			}
		},
		mounted(){
			this.searchKeyWord=this.$route.query.searchKeyWord;
			this.getSearchList(this.searchKeyWord)
		},
		methods:{
			//搜索列表
			getSearchList(searchKeyWord){
				const url=CaseSearch;
				let params={
					keywords:searchKeyWord
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){

					}
				})
			}
		}
	}
</script>
<style lang="scss">
	
</style>


// WEBPACK FOOTER //
// src/pages/Case/search.vue